import axiosInstance from "../api/axiosInstance";
import { PARTIES } from "../constants/API_URLs";

export interface PartyData {
  name: string;
  code: string;
  state: string;
  city: string;
  workingCity: string;
  address: string;
  type: string;
  categoryType: string;
  gstNumber: string;
  mobileNumber: string;
  transporter: string;
}

export const addParty = (data: any): Promise<any> => {
  return axiosInstance.post(PARTIES, data);
};

export const updateParty = (id: any, data: any): Promise<any> => {
  return axiosInstance.patch(`${PARTIES}/${id}`, data);
};

export const getParties = (params: any): Promise<any> => {
  return axiosInstance.get(PARTIES, { params });
};

export const getParty = (id: any): Promise<any> => {
  return axiosInstance.get(`${PARTIES}/${id}`);
};

export const deleteParty = (id: any): Promise<any> => {
  return axiosInstance.delete(`${PARTIES}/${id}`);
};

export const exportExcelParty = (params: any): Promise<any> => {
  return axiosInstance.get(`${PARTIES}/export/excel`, {
    params,
    responseType: "blob",
  });
};
